import {
  GET_CATEGORIES_RESPONSE,
  GET_CATEGORY_DETAILS_RESPONSE,
} from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  categoryDetails: null,
};

const categories = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CATEGORIES_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };
    case GET_CATEGORY_DETAILS_RESPONSE:
      return {
        ...state,
        categoryDetails: action.payload.categoryDetails,
      };
    default:
      return state;
  }
};

export default categories;
